<div class="d-flex justify-content-center" (keydown.enter)="$event.preventDefault()">
  <div class="stepperContainer col-lg-10 col-md-10 col-12 ">
    <div *ngIf="isConducteurSecondaireQuestion" class="col-12 d-flex justify-content-center">
      <h5 style="font-weight: bold">Informations conducteur ou conductrice secondaire</h5>
    </div>
    <mat-horizontal-stepper [linear]="isLinear" #stepper>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date de mise en circulation du véhicule : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateMEC'" [defaultDay]="currentDay" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="1940" [maxYear]="(currentYear+1)"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-end">
              <button id="next-btn" (click)="onDateMecClick(stepper)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else marquesContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #marquesContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quelle est la marque du véhicule ?</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-lg-2 col-3 buttonsContainer" *ngFor="let marque of this.marquesPopular">
                <a (click)="onMarqueClick(stepper, marque.marque.toString())" >
                  <img src="{{urlMarquesImages+marque.marque+'.jpg'}}" alt="{{marque.marque}}" class="img-thumbnail img-fluid">
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Autres marques</h5>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-lg-2 col-6 buttonsContainer" *ngFor="let marque of this.marquesNotPopular">
                <button (click)="onMarqueClick(stepper, marque.marque.toString())" mat-raised-button color="primary" class="btn-lg btn-block">
                  {{marque.marque | customTitleCase}}
                </button>
              </div>
            </div>
          </ng-template>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'marque')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else modelsContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #modelsContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quel est le modèle du véhicule ?</h5>
              </div>
            </div>
            <div class="row d-flex justify-content-around">
              <div class="col-md-4 col-lg-4 col-6 buttonsContainer" *ngFor="let modele of this.models">
                <button (click)="onModelClick(stepper,modele.model.toString())" mat-raised-button color="primary" class="btn-lg btn-block">{{modele.model | customTitleCase}}</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 d-flex justify-content-start">
                <button mat-stroked-button color="primary" (click)="goBack(stepper, 'model')"><mat-icon>chevron_left</mat-icon> Retour</button>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else alimentationsContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #alimentationsContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quel est le type d'alimentation du véhicule ?</h5>
              </div>
            </div>
            <div class="row d-flex justify-content-around">
              <div class="col-md-6 col-lg-4 col-12 buttonsContainer" *ngFor="let alimentation of this.alimentations">
                <button (click)="onAlimentationClick(stepper,alimentation.alimentation.toString())" mat-raised-button color="primary" class="btn-lg btn-block">{{alimentation.alimentation | customTitleCase}}</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 d-flex justify-content-start">
                <button mat-stroked-button color="primary" (click)="goBack(stepper, 'alimentation')"><mat-icon>chevron_left</mat-icon> Retour</button>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else chevauxContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #chevauxContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quel est le nombre de chevaux fiscaux du véhicule ?</h5>
              </div>
            </div>
            <div class="row d-flex justify-content-around">
              <div class="col-md-4 col-lg-4 col-6 buttonsContainer" *ngFor="let nombre of this.nombreChevaux">
                <button (click)="onNombreChevauxClick(stepper,nombre.chevaux)" mat-raised-button color="primary" class="btn-lg btn-block">{{nombre.chevaux}}</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 d-flex justify-content-start">
                <button mat-stroked-button color="primary" (click)="goBack(stepper, 'chevaux')"><mat-icon>chevron_left</mat-icon> Retour</button>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else carrosseriesContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #carrosseriesContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quel est le type de carrosserie du véhicule ?</h5>
              </div>
            </div>
            <div class="row d-flex justify-content-around">
              <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let carrosserie of this.carrosseries">
                <button (click)="onCarrosserieClick(stepper,carrosserie.carrosserie)" mat-raised-button color="{{'primary'}}" class="btn-lg btn-block">{{carrosserie.carrosserie | customTitleCase}}</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 d-flex justify-content-start">
                <button mat-stroked-button color="primary" (click)="goBack(stepper, 'carrosserie')"><mat-icon>chevron_left</mat-icon> Retour</button>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row" *ngIf="this.isLoading else versionsContainer">
            <div class="col-12 d-flex justify-content-center">
              <app-custom-loading></app-custom-loading>
            </div>
          </div>
          <ng-template #versionsContainer>
            <div class="row">
              <div class="col-12">
                <h5 class="text-center">Quelle est la version du véhicule ?</h5>
              </div>
            </div>
            <div class="row d-flex justify-content-around">
              <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let version of this.versions">
                <button (click)="onVersionClick(stepper, version.version)" mat-raised-button color="primary" class="btn-lg btn-block">{{version.version | customTitleCase}}</button>
              </div>
            </div>
            <br/>
            <div class="row">
              <div class="col-12 d-flex justify-content-start">
                <button mat-stroked-button color="primary" (click)="goBack(stepper, 'version')"><mat-icon>chevron_left</mat-icon> Retour</button>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le mode de stationnement du véhicule :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-6 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.stationnementReponses">
              <button (click)="onStationnementClick(stepper, reponse.value)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'stationnement')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez l'usage du véhicule :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.usagesReponses">
              <button (click)="onUsageClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'usage')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="codePostalProFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le code postal de votre lieu de travail :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="codePostalProFormGroup">
                <div class="row d-flex justify-content-around">
                  <mat-form-field>
                    <input matInput formControlName="codePostalPro" placeholder="Code Postal" required>
                  </mat-form-field>
                </div>
                <br/>
                <div class="row justify-content-between">
                  <div class="col-6 d-flex justify-content-start">
                    <button mat-stroked-button color="primary" matStepperPrevious><mat-icon>chevron_left</mat-icon> Retour</button>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <button (click)="onCodePostalProClick(stepper)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quel est le kilométrage parcouru par année ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.kilometrageReponses">
              <button (click)="onKilometrageClick(stepper, reponse.value)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'kilometrage')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le financement du véhicule :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.financementReponses">
              <button (click)="onFinancementClick(stepper, reponse.value)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'financement')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Possédez-vous une remorque ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-6 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.isRemorqueReponses">
              <button (click)="onRemorqueClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le véhicule est-il actuellement assuré ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.isVehiculeActuellementAssureReponses">
              <button (click)="onVehiculeAssureClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Votre véhicule est-il aménagé pour la conduite ou le transport de personnes à mobilité réduite ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isVehiculeAmenagePMRReponses">
              <button (click)="onVehiculeAmenagePMRClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('eteAssure36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12 buttonsContainer" *ngFor="let reponse of this.isAssure36DerniersMoisReponses">
              <button (click)="onEteAssure36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="bonusMalusFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le bonus/malus :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="bonusMalusFormGroup">
                <div class="row">
                  <div class="col-12 d-flex justify-content-center">
                      <mat-form-field appearance="fill">
                        <mat-select formControlName="bonusMalus">
                          <mat-option *ngFor="let bonusMalus of bonusMalusValues" [value]="bonusMalus.value">
                            {{bonusMalus.viewValue}}
                          </mat-option>
                        </mat-select>
                      <div *ngIf="bonusMalusFormGroup.controls['bonusMalus'].invalid && (bonusMalusFormGroup.controls['bonusMalus'].dirty || bonusMalusFormGroup.controls['bonusMalus'].touched)">
                        <mat-error *ngIf="bonusMalusFormGroup.controls['bonusMalus'].errors.required">
                          Le champ bonus/malus est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>
              </form>
              <div class="row justify-content-between">
                <div class="col-6 d-flex justify-content-start">
                  <button mat-stroked-button color="primary" (click)="goBack(stepper, 'bonusMalus')"><mat-icon>chevron_left</mat-icon> Retour</button>
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <button (click)="onBonusMalusClick(stepper, this.bonusMalusReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nombre d'année de bonus à 0.50 : </h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-2 col-lg-2 col-3 buttonsContainer" *ngFor="let reponse of this.nbrAnneeBonusCinquanteReponses">
              <button (click)="onNbrAnneeBonusCinquanteClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nombre de mois assurés durant les 36 derniers mois :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-2 col-lg-2 col-3 buttonsContainer" *ngFor="let reponse of this.periodeAssure36DerniersMoisReponses">
              <button (click)="onPeriodeAssure36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'periodeAssure36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('eteResilie36DerniersMoisReponses',  this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.eteResilie36DerniersMoisReponses">
              <button (click)="onEteResilie36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'eteResilie36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quel est le motif de la résiliation ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.motifResiliation36DerniersMoisReponses">
              <button (click)="onMotifResiliation36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'motifResiliation36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nombre de mois d'interruption d'assurance au cours des 36 derniers mois ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-2 col-lg-2 col-3 buttonsContainer" *ngFor="let reponse of this.dureeNonPaiementReponses">
              <button (click)="onDureeNonPaiementClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.value}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dureeNonPaiement')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('nombreAssureursResiliationNonPaiement', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-3 col-lg-3 col-4 buttonsContainer" *ngFor="let reponse of this.nombreAssureursResiliationNonPaiementReponses">
              <button (click)="onAssureursResiliationNonPaiementClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.value}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'nombreAssureursResiliationNonPaiement')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Récidive Non paiement ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.recidiveResiliationNonPaiementReponses">
              <button (click)="onRecidiveResiliationNonPaiementClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Contentieux soldé ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.contentieuxSoldeResiliationNonPaiementReponses">
              <button (click)="onContentieuxSoldeResiliationNonPaiementClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date de résiliation : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateResiliation36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-3" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dateResiliation36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateResiliation36DerniersMoisClick(stepper, this.dateResiliation36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isEuSinistres36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isEuSinistres36DerniersMoisReponses">
              <button (click)="onIsEuSinistres36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isEuSinistres36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.nombreMaxSinistresADeclarerForTemplate; let i = index' >
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quelle est la nature du {{i | frenchTextPositions}} sinistre ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-lg-6 col-md-6 col-12 buttonsContainer" *ngFor="let reponse of this.natureSinistres36DerniersMoisReponses[i]">
              <button (click)="onNatureSinistres36DerniersMoisClick(stepper, reponse, i)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'natureSinistres36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.nombreMaxSinistresADeclarerForTemplate; let i = index'>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isDelitDeFuiteSinistres36DerniersMois', this._typeConducteur)}} {{i | frenchTextPositions}} sinistre ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isDelitDeFuiteSinistres36DerniersMoisReponses[i]">
              <button (click)="onDelitDeFuiteSinistres36DerniersMoisClick(stepper, reponse, i)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isDelitDeFuiteSinistres36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.isInterventionForceDeLOrdreSinistres36DerniersMoisReponses; let i = index'>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Intervention de la gendarmerie/police pendant le {{i | frenchTextPositions}} sinistre ? </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isInterventionForceDeLOrdreSinistres36DerniersMoisReponses[i]">
              <button (click)="onInterventionForceDeLOrdreSinistres36DerniersMoisClick(stepper, reponse, i)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isInterventionForceDeLOrdreSinistres36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.poursuiteTribunalPoliceSinistres36DerniersMoisReponses; let i = index'>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quel est le type de poursuite pendant le {{i | frenchTextPositions}} sinistre ? </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.poursuiteTribunalPoliceSinistres36DerniersMoisReponses[i]">
              <button (click)="onPoursuiteTribunalPoliceSinistres36DerniersMoisClick(stepper, reponse, i)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isInterventionForceDeLOrdreSinistres36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.isPresenceTiersSinistres36DerniersMoisReponses; let i = index'>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le {{i | frenchTextPositions}} sinistre a-t-il été occasionné en présence d'un tiers identifié ? </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isPresenceTiersSinistres36DerniersMoisReponses[i]">
              <button (click)="onPresenceTiersSinistres36DerniersMoisClick(stepper, reponse, i)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isPresenceTiersSinistres36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step *ngFor='let sinistresLoop of this.nombreMaxSinistresADeclarerForTemplate; let i = index'>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date du {{i | frenchTextPositions}} sinistre : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateSinistre_' + i" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-3" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dateSinistre36DerniersMois_' + i)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateSinistre36DerniersMoisClick(stepper, this.dateSinistre36DerniersMoisReponse[i], i)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isEuSanctionsPenalesOuAdministratives', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isEuSanctionsPenalesOuAdministrativesReponses">
              <button (click)="onIsEuSanctionsPenalesOuAdministrativesClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isEuSanctionsPenalesOuAdministratives')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isEuAlcoolemie36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isEuAlcoolemie36DerniersMoisReponses">
              <button (click)="onIsEuAlcoolemie36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isEuAlcoolemie36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date du dernier test d'alcoolémie : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateDernierAlcoolemie36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dateDernierAlcoolemie36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateDernierAlcoolemie36DerniersMoisClick(stepper, this.dateDernierAlcoolemie36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isRefusTestAlcoolemie36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isRefusTestAlcoolemie36DerniersMoisReponses">
              <button (click)="onIsRefusTestAlcoolemie36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isRefusTestAlcoolemie36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isDelitDeFuiteAlcoolemie36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isDelitDeFuiteAlcoolemie36DerniersMoisReponses">
              <button (click)="onIsDelitDeFuiteAlcoolemie36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isDelitDeFuiteAlcoolemie36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le test d'alcoolémie a été effectué suite à :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.controleAlcoolemieSuiteA36DerniersMoisReponses">
              <button (click)="onControleAlcoolemieSuiteA36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'controleAlcoolemieSuiteA36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le test d'alcoolémie a été effectué avec :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.controleAlcoolemieMethode36DerniersMoisReponses">
              <button (click)="onControleAlcoolemieMethodeDerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'controleAlcoolemieMethode36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="tauxAlcoolemieFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le taux d'alcoolémie relevé lors du test ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="tauxAlcoolemieFormGroup">
                <div class="row d-flex justify-content-around">
                  <mat-form-field>
                    <input matInput formControlName="tauxAlcoolemie" placeholder="" required>
                    <div *ngIf="tauxAlcoolemieFormGroup.controls['tauxAlcoolemie'].invalid && (tauxAlcoolemieFormGroup.controls['tauxAlcoolemie'].dirty || tauxAlcoolemieFormGroup.controls['tauxAlcoolemie'].touched)">
                      <mat-error *ngIf="tauxAlcoolemieFormGroup.controls['tauxAlcoolemie'].errors.pattern">
                        Merci d'indiquer le taux d'alcoolémie au format suivant : x.xx
                      </mat-error>
                    </div>
                  </mat-form-field>
                </div>
                <br/>
                <div class="row justify-content-between">
                  <div class="col-6 d-flex justify-content-start">
                    <button mat-stroked-button color="primary" matStepperPrevious><mat-icon>chevron_left</mat-icon> Retour</button>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <button (click)="onTauxAlcoolemieClick(stepper, this.tauxAlcoolemie36DerniersMoisReponse)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isEuStupefiant36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isEuStupefiant36DerniersMoisReponses">
              <button (click)="onIsEuStupefiant36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isEuStupefiant36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date du dernier test de stupéfiants : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateDernierStupefiant36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dateDernierStupefiant36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateDernierStupefiant36DerniersMoisClick(stepper, this.dateDernierStupefiant36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isRefusTestAlcoolemie36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isRefusTestStupefiant36DerniersMoisReponses">
              <button (click)="onIsRefusTestStupefiant36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isRefusTestStupefiant36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isDelitDeFuiteAlcoolemie36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isDelitDeFuiteStupefiant36DerniersMoisReponses">
              <button (click)="onIsDelitDeFuiteStupefiant36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'isDelitDeFuiteStupefiant36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le test de stupéfiants a été effectué suite à :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.controleStupefiantSuiteA36DerniersMoisReponses">
              <button (click)="onControleStupefiantSuiteA36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'controleStupefiantSuiteA36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Le test de stupéfiants a été effectué avec :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.controleStupefiantMethode36DerniersMoisReponses">
              <button (click)="onControleStupefiantMethodeDerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'controleStupefiantMethode36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('isAnnulationOuSuspensionPermis36DerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.isAnnulationOuSuspensionPermis36DerniersMoisReponses">
              <button (click)="onIsAnnulationOuSuspensionPermis36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">L'annulation du permis est survenue suite à un sinistre ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.annulationPermisAvecOuSansSinistre36DerniersMoisReponses">
              <button (click)="onAnnulationPermisAvecOuSansSinistre36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'annulationPermisAvecOuSansSinistre36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date d'obtention du premier permis annulé : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateInitialPermisApresAnnulation'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="1940" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateInitialPermisApresAnnulationClick(stepper, this.dateInitialPermisApresAnnulationReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le motif de l'annulation du permis : </h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.annulationPermisMotif36DerniersMoisReponses">
              <button (click)="onAnnulationPermisMotif36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'annulationPermisMotif36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date d'annulation du permis : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateAnnulationPermis36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'dateAnnulationPermis36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateAnnulationPermis36DerniersMoisClick(stepper, this.dateAnnulationPermis36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le motif de la suspension du permis : </h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.suspensionPermisMotif36DerniersMoisReponses">
              <button (click)="onSuspensionPermisMotif36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper, 'suspensionPermisMotif36DerniersMois')"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date de la suspension du permis : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateSuspensionPermis36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateSuspensionPermis36DerniersMoisClick(stepper, this.dateSuspensionPermis36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('nombreSuspensionPermis36AvecSinistreDerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-3 buttonsContainer" *ngFor="let reponse of this.nombreSuspensionPermis36AvecSinistreDerniersMoisReponses">
              <button (click)="onNombreSuspensionPermis36AvecSinistreDerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.value}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('nombreSuspensionPermis36SansSinistreDerniersMois', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-3 buttonsContainer" *ngFor="let reponse of this.nombreSuspensionPermis36SansSinistreDerniersMoisReponses">
              <button (click)="onNombreSuspensionPermis36SansSinistreDerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.value}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nombre de mois de suspension ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-3 buttonsContainer" *ngFor="let reponse of this.nombreMoisSuspensionPermis36DerniersMoisReponses">
              <button (click)="onNombreMoisSuspensionPermis36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.value}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date d'infraction qui a causée cette sanction : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateInfraction36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateInfraction36DerniersMoisClick(stepper, this.dateInfractionPermis36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date de la sanction : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateSanction36DerniersMois'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="currentYear" [minYear]="currentYear-5" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateSanction36DerniersMoisClick(stepper, this.dateSanctionPermis36DerniersMoisReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nombre de mois de la sanction :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-2 col-lg-2 col-3 buttonsContainer" *ngFor="let reponse of this.dureeSanction36DerniersMoisReponses">
              <button (click)="onDureeSanction36DerniersMoisClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la civilité: </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.civiliteConducteurPrincipaleReponses">
              <button (click)="onCiviliteConducteurPrincipaleClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="nomConducteurPrincipaleFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le nom et prénom :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="nomConducteurPrincipaleFormGroup">
                <div class="row d-flex justify-content-around">
                  <p>
                    <mat-form-field>
                      <input matInput formControlName="nom" placeholder="Nom " required>
                      <div *ngIf="nomConducteurPrincipaleFormGroup.controls['nom'].invalid && (nomConducteurPrincipaleFormGroup.controls['nom'].dirty || nomConducteurPrincipaleFormGroup.controls['nom'].touched)">
                        <mat-error *ngIf="nomConducteurPrincipaleFormGroup.controls['nom'].errors.required">
                          Le nom est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </p>
                  <p>
                    <mat-form-field>
                      <input matInput formControlName="prenom" placeholder="Prénom" required>
                      <div *ngIf="nomConducteurPrincipaleFormGroup.controls['prenom'].invalid && (nomConducteurPrincipaleFormGroup.controls['prenom'].dirty || nomConducteurPrincipaleFormGroup.controls['prenom'].touched)">
                        <mat-error *ngIf="nomConducteurPrincipaleFormGroup.controls['prenom'].errors.required">
                          Le prénom est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </p>
                </div>
                <br/>
                <div class="row justify-content-between">
                  <div class="col-6 d-flex justify-content-start">
                    <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <button [disabled]="nomConducteurPrincipaleFormGroup.pristine || nomConducteurPrincipaleFormGroup.invalid" (click)="onNomConducteurPrincipaleClick(stepper, this.nomConducteurPrincipaleReponse)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date de naissance : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'dateNaissanceConducteurPrincipal'" [defaultYear]="currentYear-21" [minYear]="1940" [maxYear]="currentYear-18" (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDateNaissanceConducteurPrincipalClick(stepper, this.dateNaissanceConducteurPrincipalReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la date d'obtention du permis : </h5>
            </div>
          </div>
          <app-date-scroll *ngIf="currentYear" [fieldName]="'datePermisConducteurPrincipal'" [defaultDay]="1" [defaultMonth]="currentMonth" [defaultYear]="this.defaultFormValues.datePermisDefaultYearProspect" [minYear]="1940" [maxYear]="currentYear"  (dateChange)="onDateChange($event)"></app-date-scroll>
          <br/>
          <div class="row justify-content-between">
            <div class="col-6 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
            <div class="col-6 d-flex justify-content-end">
              <button (click)="onDatePermisConducteurPrincipalClick(stepper, this.datePermisConducteurPrincipalReponse)" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quel est le type du permis ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.typePermisConducteurPrincipalReponses">
              <button (click)="onTypePermisConducteurPrincipalClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">{{this.getStepQuestionLabel('paysConduiteHorsEuropeConducteurPrincipal', this._typeConducteur)}}</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-md-3 col-lg-3 col-12"><mat-checkbox class="example-margin" [(ngModel)]="this.formModel[this._typeConducteur].isConduiteMaroc">Oui au Maroc</mat-checkbox></div>
                <div class="col-md-3 col-lg-3 col-12"><mat-checkbox class="example-margin" [(ngModel)]="this.formModel[this._typeConducteur].isConduiteTunisie">Oui à Tunisie</mat-checkbox></div>
                <div class="col-md-3 col-lg-3 col-12"><mat-checkbox class="example-margin" [(ngModel)]="this.formModel[this._typeConducteur].isConduiteRussie">Oui en Russie</mat-checkbox></div>
                <div class="col-md-3 col-lg-3 col-12"><mat-checkbox class="example-margin" [(ngModel)]="this.formModel[this._typeConducteur].isConduiteTurquie">Oui en Turquie</mat-checkbox></div>
              </div>
              <br/>
              <div class="row justify-content-between">
                <div class="col-6 d-flex justify-content-start">
                  <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <button (click)="onPaysConduiteHorsEuropeConducteurPrincipalReponseClick(stepper, this.paysConduiteHorsEuropeConducteurPrincipalReponse)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le titulaire de la carte grise : </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-6 col-12 buttonsContainer" *ngFor="let reponse of this.titulaireCarteGriseReponses">
              <button (click)="onTitulaireCarteGriselClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la situation familiale :</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-3 col-lg-3 col-6 buttonsContainer" *ngFor="let reponse of this.situationFamilialeConducteurPrincipalReponses">
              <button (click)="onSituationFamilialeConducteurPrincipalClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Quel est le lien de parenté avec le conducteur principal ?</h5>
            </div>
          </div>
          <div class="row d-flex justify-content-around">
            <div class="col-md-3 col-lg-3 col-6 buttonsContainer" *ngFor="let reponse of this.lienAvecConducteurPrincipalReponses">
              <button (click)="onLienAvecConducteurPrincipalClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la profession :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.professionConducteurPrincipalReponses">
              <button (click)="onProfessionConducteurPrincipalClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="adresseConducteurPrincipaleFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez l'adresse :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="adresseConducteurPrincipaleFormGroup">
                <div class="row">
                  <div class="col-12 d-flex justify-content-center">
                    <mat-form-field>
                      <textarea matInput formControlName="adresse"  placeholder="Adresse" required></textarea>
                      <div *ngIf="adresseConducteurPrincipaleFormGroup.controls['adresse'].invalid && (adresseConducteurPrincipaleFormGroup.controls['adresse'].dirty || adresseConducteurPrincipaleFormGroup.controls['adresse'].touched)">
                        <mat-error *ngIf="adresseConducteurPrincipaleFormGroup.controls['adresse'].errors.required">
                          Le champ adresse est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-12 d-flex justify-content-center">
                    <mat-form-field>
                      <input matInput formControlName="codePostal" placeholder="Code postal" required>
                      <div *ngIf="adresseConducteurPrincipaleFormGroup.controls['codePostal'].invalid && (adresseConducteurPrincipaleFormGroup.controls['codePostal'].dirty || adresseConducteurPrincipaleFormGroup.controls['codePostal'].touched)">
                        <mat-error *ngIf="adresseConducteurPrincipaleFormGroup.controls['codePostal'].errors.required">
                          Le champ code postal est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6 col-12 d-flex justify-content-center">
                    <mat-form-field>
                      <input matInput formControlName="ville" placeholder="Ville" required>
                      <div *ngIf="adresseConducteurPrincipaleFormGroup.controls['ville'].invalid && (adresseConducteurPrincipaleFormGroup.controls['ville'].dirty || adresseConducteurPrincipaleFormGroup.controls['ville'].touched)">
                        <mat-error *ngIf="adresseConducteurPrincipaleFormGroup.controls['ville'].errors.required">
                          Le champ ville est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>
                <br/>
                <div class="row justify-content-between">
                  <div class="col-6 d-flex justify-content-start">
                    <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <button [disabled]="adresseConducteurPrincipaleFormGroup.pristine || adresseConducteurPrincipaleFormGroup.invalid" (click)="onAdresseConducteurPrincipalClick(stepper, this.adresseConducteurPrincipalReponse)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="contactConducteurPrincipaleFormGroup">
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez le téléphone et l'adresse mail :</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="contactConducteurPrincipaleFormGroup">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-12 d-flex justify-content-center">
                    <mat-form-field>
                      <input matInput type="tel" formControlName="tel" placeholder="Téléphone" required>
                      <div *ngIf="contactConducteurPrincipaleFormGroup.controls['tel'].invalid && (contactConducteurPrincipaleFormGroup.controls['tel'].dirty || contactConducteurPrincipaleFormGroup.controls['tel'].touched)">
                        <mat-error *ngIf="contactConducteurPrincipaleFormGroup.controls['tel'].errors.required">
                          Le champ téléphone est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-lg-6 col-12 d-flex justify-content-center">
                    <mat-form-field>
                      <input matInput type="email" formControlName="email" placeholder="Email" required>
                      <div *ngIf="contactConducteurPrincipaleFormGroup.controls['email'].invalid && (contactConducteurPrincipaleFormGroup.controls['email'].dirty || contactConducteurPrincipaleFormGroup.controls['email'].touched)">
                        <mat-error *ngIf="contactConducteurPrincipaleFormGroup.controls['email'].errors.required">
                          Le champ adresse mail est obligatoire.
                        </mat-error>
                      </div>
                    </mat-form-field>
                  </div>
                </div>
                <br/>
                <div class="row justify-content-between">
                  <div class="col-6 d-flex justify-content-start">
                    <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
                  </div>
                  <div class="col-6 d-flex justify-content-end">
                    <button [disabled]="contactConducteurPrincipaleFormGroup.pristine || contactConducteurPrincipaleFormGroup.invalid" (click)="onContactConducteurPrincipalClick(stepper, this.contactConducteurPrincipalReponse)" type="submit" mat-raised-button color="primary">Suivant <mat-icon>chevron_right</mat-icon></button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Indiquez la garantie souhaitée : </h5>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-lg-4 col-12 buttonsContainer" *ngFor="let reponse of this.garantieSouhaiteeConducteurPrincipalReponses">
              <button (click)="onGarantieSouhaiteeConducteurPrincipalClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <div>
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">Souhaitez-vous désigner un second conducteur ?</h5>
            </div>
          </div>
          <div class="row">
            <div class="col-6 buttonsContainer" *ngFor="let reponse of this.isAjouterConducteurSecondairReponses">
              <button (click)="onIsAjouterConducteurSecondairClick(stepper, reponse)" mat-raised-button color="primary" class="btn-lg btn-block">{{reponse.label}}</button>
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-12 d-flex justify-content-start">
              <button mat-stroked-button color="primary" (click)="goBack(stepper)"><mat-icon>chevron_left</mat-icon> Retour</button>
            </div>
          </div>
        </div>
      </mat-step>
      <mat-step>
        <app-chargement></app-chargement>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
